var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"音檔播放","visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.innerVisible = false}}},[_vm._v("關閉")])]},proxy:true}])},[_c('aplayer',{attrs:{"autoplay":"","music":{
      title: _vm.assetName,
      artist: ' ',
      src: _vm.audioSrc,
      pic: '/img/amrtf.jpg',
      theme: 'pic',
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }